<template>
  <div>
    <Header>One Time Ride List</Header>
    <div class="tiled-bar-image"></div>

    <Main>
      <OneTimeRideList />
    </Main>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import OneTimeRideList from '../components/OneTimeRideList.vue'

export default {
  name: 'OneTimeRideListPage',

  components: {
    Header,
    Main,
    OneTimeRideList,
  },
}
</script>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>